export function formDataToObject(formData) {
    if (!(formData instanceof FormData)) {
        throw new Error('Not an instance of FormData');
    }

    return Array.from(new Set(formData.keys())).reduce((object, key) => {
        object[key] = formData.getAll(key).length > 1 ? formData.getAll(key).join(', ') : formData.get(key);

        return object
    }, {})
}